import { render } from "./drawerRoomType.vue?vue&type=template&id=fe84ba94&scoped=true"
import script from "./drawerRoomType.vue?vue&type=script&lang=js"
export * from "./drawerRoomType.vue?vue&type=script&lang=js"

import "./drawerRoomType.vue?vue&type=style&index=0&id=fe84ba94&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe84ba94"]])

export default __exports__